<ng-container *ngIf="items$|async as items">
	<div *ngIf="items.length" class="linq-feedback-panel linq-feedback-panel--{{ variant }}">
		<ng-container *ngFor="let item of items; key: 'id'; let i = index">
			<div *ngIf="i === 0 || expanded" class="linq-feedback-panel__item">
				<span class="linq-feedback-panel__icon">{{ variant === 'error' ? 'error' : 'warning' }}</span>
				<div class="linq-feedback-panel__message" aria-live="polite" role="alert">{{ item.message }}</div>
				<div class="linq-feedback-panel__actions">
					<button *ngIf="messageTotal > 1 && i === 0 && !expanded" (click)="expand()">View all warnings ({{ messageTotal }})</button>
					<button *ngIf="messageTotal > 1 && i === 0" (click)="clear()">Clear All</button>
					<button mat-icon-button aria-label="Clear message" (click)="clear(item.id)">
						<mat-icon>clear</mat-icon>
					</button>
				</div>
			</div>
		</ng-container>
	</div>
</ng-container>
